import { ItemList } from '../orm'

class DropdownOptions extends ItemList {

    constructor(dropdown_name) {
        super(`photographer_options__${dropdown_name}`)
        this.url = `photographer/dropdown_options/${dropdown_name}`
    }

    getEntityKey() {
        return this.url
    }

    fetchWithFilter(filterParams) {
        return (dispatch) => {
            dispatch(this.clearListFilter());
            dispatch(this.updateListFilter(filterParams));
            dispatch(this.invalidateList());
            return dispatch(this.fetchListIfNeeded(true));
        };
    }
}

export const sportTagsDropdownOptions = new DropdownOptions('sport_tags')
export const shotAtDateDropdownOptions = new DropdownOptions('shot_at_dates')
export const shotAtTimeDropdownOptions = new DropdownOptions('shot_at_times')
export const sessionNameDropdownOptions = new DropdownOptions('session_names')
export const activityTagDropdownOptions = new DropdownOptions('activity_tags')
export const genreTagDropdownOptions = new DropdownOptions('get_all_genre_tags')
export const albumDropdownOptions = new DropdownOptions('albums')
export const galleryEventDropdownOptions = new DropdownOptions('gallery_events')
// All events and albums (not filtered by photographer usage)
export const allGalleryEventDropdownOptions = new DropdownOptions('get_all_gallery_events')
export const allAlbumDropdownOptions = new DropdownOptions('get_all_albums')
